import React, { ReactElement } from 'react';
import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';
import { useSeoSocialInfo } from '../service';
import { SocialTagsProps } from '../types';

export const SocialTags = ({ config }: SocialTagsProps): (ReactElement | null)[] => {
  const socialInfo = useSeoSocialInfo();
  const { description: defaultDescription, title: defaultTitle, shortName, ogImage: defaultImage } = config;
  const siteName = shortName;

  const metaTags = [
    { property: 'og:title', content: socialInfo.title || defaultTitle },
    { property: 'og:description', content: socialInfo.description || defaultDescription },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: getImage(socialInfo.socialImagesData, 'large') || defaultImage },
    { property: 'og:image:alt', content: socialInfo.title || defaultTitle },
    { property: 'og:locale', content: 'pt_BR' },
    { property: 'og:site_name', content: siteName },
  ];

  return metaTags.map(metaTag => (metaTag.content ? <meta key={metaTag.property} {...metaTag} /> : null));
};
